module.exports = __webpack_public_path__ + "static/media/85.c9711158.jpg";